import Seo from "./Seo";
import { WhatsappLogo, Calendar, Sparkle, ChatText, Upload, Users, ChartLineUp, DeviceMobile, Clock, ShieldCheck } from "@phosphor-icons/react";

const FEATURES = [
  { icon: WhatsappLogo, title: "WhatsApp Reminders (Meta Cloud API)", desc: "Send service reminders straight to customers' WhatsApp — one tap from the dashboard or fully automated via the daily digest." },
  { icon: Calendar, title: "Automatic Due-Date Tracking", desc: "Enter last-service date + interval once. Every customer's next service is auto-computed and re-computed each time you mark them serviced." },
  { icon: Sparkle, title: "AI-Suggested Service Intervals", desc: "Pick your business type (Car Garage, Dental, RO, etc.) and DueMate's AI suggests the right interval, saving you research time." },
  { icon: ChatText, title: "Per-Business Message Templates", desc: "Author WhatsApp templates per business type with dynamic placeholders (customer name, next date, next km, business name)." },
  { icon: Upload, title: "CSV Bulk Import", desc: "Migrate your existing customer list in seconds — up to 5,000 rows per import, with per-row validation and error reporting." },
  { icon: Users, title: "Kilometre Tracking (Car / Bike)", desc: "For garages and bike-service centres, track by odometer reading in addition to date — reminders fire when either milestone hits." },
  { icon: Clock, title: "Auto-Mark-Serviced from Replies", desc: "When a customer replies 'done' or 'yes' on WhatsApp, DueMate auto-advances their next-service date and thanks them by name." },
  { icon: ChartLineUp, title: "Real-time Dashboard Stats", desc: "Total customers, overdue, due-in-7-days, and messages sent this month — visible the moment you log in." },
  { icon: DeviceMobile, title: "Installable Mobile PWA", desc: "Install DueMate on your Android or iPhone from Chrome / Safari and it opens like a native app — with an offline-capable app shell." },
  { icon: ShieldCheck, title: "Per-tenant Data Isolation", desc: "Every business's customers, templates, and history are strictly scoped to that account — with rate limits and CSRF protection on all mutations." },
];

export default function Features() {
  return (
    <>
      <Seo
        title="Features — DueMate"
        description="Every feature in DueMate: WhatsApp reminders via Meta Cloud API, AI service intervals, CSV import, per-business templates, kilometre tracking, and an installable mobile PWA."
      />
      <section className="max-w-[1200px] mx-auto px-4 sm:px-6 pt-12 pb-8">
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#4361EE]">Features</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter mt-2">Everything you need to keep customers coming back.</h1>
        <p className="text-base text-[#4A4A4A] font-semibold mt-4 max-w-2xl">
          DueMate is built around one job: making sure every customer gets a timely reminder for their next service. Here's how it does it.
        </p>
      </section>

      <section className="max-w-[1200px] mx-auto px-4 sm:px-6 pb-16 grid md:grid-cols-2 gap-5">
        {FEATURES.map(({ icon: Icon, title, desc }) => (
          <div key={title} className="nb-card p-6" data-testid={`feature-${title.split(" ")[0].toLowerCase()}`}>
            <div className="w-11 h-11 bg-[#4ECDC4] border-2 border-black rounded-md flex items-center justify-center mb-4">
              <Icon size={22} weight="bold" />
            </div>
            <h3 className="font-heading text-xl font-black mb-2">{title}</h3>
            <p className="text-sm text-[#4A4A4A] font-semibold">{desc}</p>
          </div>
        ))}
      </section>
    </>
  );
}
